import StandardRed from './StandardRed'
export default StandardRed